import React from "react";
import Signature from "@features/port-security/components/occupation-info/Signature.tsx";
import VisitDetails from "@features/port-security/components/security-clearance-application/VisitDetails.tsx";
import VisitDetailsAndDocuments from "@features/port-security/components/security-clearance-application/VisitDetailsAndDocuments.tsx";

const SecurityClearanceApplicationForm: React.FC = () => {
  return (
    <div data-testid="security-clearance-application-form" className="flex flex-col gap-8">
      <VisitDetailsAndDocuments />
      <VisitDetails />
      <Signature />
    </div>
  );
};

export default SecurityClearanceApplicationForm;
